import { Workflow, GitBranch, Zap, Settings } from "lucide-react";
import heroImage from "@/assets/hero-person-workflows.png";
import ProductHeroI18n from "../shared/ProductHeroI18n";

const AutomationWorkflowsHero = () => {
  return (
    <ProductHeroI18n
      translationPrefix="automationPage"
      heroImage={heroImage}
      imageAlt="Chathero AI Workflows & Automation"
      floatingIcons={[
        { icon: Workflow, color: "mint" },
        { icon: GitBranch, color: "orange" },
        { icon: Zap, color: "primary" },
        { icon: Settings, color: "mint" },
      ]}
    />
  );
};

export default AutomationWorkflowsHero;
